import type { GetServerSideProps } from 'next';
import feature_blackfriday_sale_2025 from '../../../public/images/feature_blackfriday_sale_2025.png';
import { createFeatureNamePage } from '../../features/featurePages/featureNameTemplate';
import type { CommonFeatureSSRProps } from '../../server/features/commonFeatureServerSideProps';

export const getServerSideProps: GetServerSideProps<CommonFeatureSSRProps> =
  async (ctx) => {
    const { commonFeatureGetServerSideProps } = await import(
      '../../server/features/commonFeatureServerSideProps'
    );
    return commonFeatureGetServerSideProps(ctx);
  };

export default createFeatureNamePage({
  slug: 'blackfridaysale_2025',
  featureName: 'BFセール',
  title: 'ブラックフライデーセールメニュー一覧',
  description: 'あの占い師も特別価格で！期間限定のセールメニュー特集',
  ogImageUrl: 'https://raysee.jp/images/feature_blackfriday_sale_2025.png',
  heroImage: feature_blackfriday_sale_2025,
});
